import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";

const ListComponent = ({ type = "DEFAULT", items }) => {
  return (
    <div style={{ padding: 20, paddingBottom: 25, paddingTop: 0 }}>
      <ListGroup>
        {type === "DEFAULT" && (
          <>
            {items.map((item) => (
              <ListGroupItem
                onClick={async () => {
                  if (item.action) await item.action(item);
                }}
                tag="a"
              >
                {item.icon && (
                  <span style={{ marginRight: 10 }}>
                    <FontAwesomeIcon icon={item.icon} />
                  </span>
                )}
                {item.name}
              </ListGroupItem>
            ))}
          </>
        )}

        {type === "KEY_VALUE" && (
          <>
            {items &&
              items.map((item) => (
                <ListGroupItem>
                  <div className="row">
                    <div className="col-6"> {item.key}</div>
                    <div className="col-6" style={{ textAlign: "right" }}>
                      {item.value}
                    </div>
                  </div>
                </ListGroupItem>
              ))}
          </>
        )}
      </ListGroup>
    </div>
  );
};

export default ListComponent;
